export default __webpack_public_path__ + "static/media/custom_chart.3eb9a795.svg";